(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nfb-product"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".nfb-product").forEach(function (section) {

    /* IMAGE GALLERY */

    const slides = section.querySelectorAll("[data-nfb-product-slide]");
    const prevButton = section.querySelector("[data-nfb-gallery-prev]");
    const nextButton = section.querySelector("[data-nfb-gallery-next]");

    let currentSlide = 0;

    function showSlide(index) {
      if (!slides.length) return;

      if (index < 0) {
        index = slides.length - 1;
      }

      if (index >= slides.length) {
        index = 0;
      }

      slides.forEach(function (slide, slideIndex) {
        const isActive = slideIndex === index;

        slide.hidden = !isActive;
        slide.classList.toggle("is-active", isActive);
      });

      currentSlide = index;
    }

    prevButton?.addEventListener("click", function () {
      showSlide(currentSlide - 1);
    });

    nextButton?.addEventListener("click", function () {
      showSlide(currentSlide + 1);
    });

    /* QUANTITY */

    const quantityInput = section.querySelector("[data-nfb-quantity]");
    const minusButton = section.querySelector("[data-nfb-quantity-minus]");
    const plusButton = section.querySelector("[data-nfb-quantity-plus]");

    minusButton?.addEventListener("click", function () {
      const value = parseInt(quantityInput.value, 10) || 1;

      quantityInput.value = Math.max(1, value - 1);
    });

    plusButton?.addEventListener("click", function () {
      const value = parseInt(quantityInput.value, 10) || 1;

      quantityInput.value = value + 1;
    });

    /* VARIANT */

    const variantSelect = section.querySelector("[data-nfb-variant-select]");
    const variantId = section.querySelector("[data-nfb-variant-id]");
    const price = section.querySelector("[data-nfb-product-price]");

    variantSelect?.addEventListener("change", function () {
      const selectedOption =
        variantSelect.options[variantSelect.selectedIndex];

      variantId.value = selectedOption.value;

      if (selectedOption.dataset.price) {
        price.textContent = selectedOption.dataset.price;
      }
    });

  });
});


  } catch(e) { console.error(e); }
})();
})();
